import { darken, getContrastRatio, lighten } from '@mui/material/styles'

const adjustColorContrast = (color, theme) => {
  if (
    getContrastRatio(color, theme.palette.background.paper) >=
    theme.palette.contrastThreshold
  )
    return color
  return adjustColorContrast(
    theme.palette.mode === 'light'
      ? darken(color, 0.1)
      : lighten(color, 0.1),
    theme,
  )
}

export default adjustColorContrast
